import { useEffect, useState } from "react";

import type { ContentGateRestriction } from "@ui/components/ContentGate";

import { isServerSide } from "@jti/fe-common";
import { getAddressByIp, useMapApi } from "@jti/rest-api";

export const useContentGateIPRestrictions = (restrictionText: string, countriesApiUrl?: string) => {
  const [restrictionWithRedirections, setRestrictionWithRedirections] = useState<ContentGateRestriction[]>([]);
  const mapApi = useMapApi();

  const setRedirectionUrl = async () => {
    const DEFAULT_URL = "https://www.ploom.com";

    if (isServerSide() || window.location.origin === DEFAULT_URL) {
      return;
    }

    const [ipAddress, enabledCountries] = await Promise.all([
      getAddressByIp(),
      mapApi.getSelectedCountries(countriesApiUrl),
    ]);

    if (ipAddress?.whitelisted) {
      return;
    }

    const selectedCountry = enabledCountries?.[0]?.data.find(
      (country) => country.code === ipAddress.countryRegion?.isoCode
    );

    if (selectedCountry) {
      const { href } = window.location;
      const url = new URL(selectedCountry.data?.MarketUrl);
      const pathname = url.pathname === "/" ? "" : url.pathname;
      const isAccessible = href?.includes(url.origin + pathname);

      if (!isAccessible) {
        setRestrictionWithRedirections([
          { label: restrictionText, link: selectedCountry.data?.MarketUrl || DEFAULT_URL },
        ]);
      }
    } else if (!DEFAULT_URL.includes(window.location.origin)) {
      setRestrictionWithRedirections([{ label: restrictionText, link: DEFAULT_URL }]);
    }
  };

  useEffect(() => {
    setRedirectionUrl();
  }, []);

  return { activeRestrictions: restrictionWithRedirections };
};
